let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("51EOq")).then(() => parcelRequire('9SCOA'));